import { render, staticRenderFns } from "./HomeVoicesQuote.vue?vue&type=template&id=3823cd6f&scoped=true"
import script from "./HomeVoicesQuote.vue?vue&type=script&lang=js"
export * from "./HomeVoicesQuote.vue?vue&type=script&lang=js"
import style0 from "./HomeVoicesQuote.vue?vue&type=style&index=0&id=3823cd6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823cd6f",
  null
  
)

export default component.exports